import { render, staticRenderFns } from "./EinstellungenPage.vue?vue&type=template&id=12e3299a&scoped=true&"
import script from "./EinstellungenPage.vue?vue&type=script&lang=ts&"
export * from "./EinstellungenPage.vue?vue&type=script&lang=ts&"
import style0 from "./EinstellungenPage.vue?vue&type=style&index=0&id=12e3299a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3299a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
